import get from 'lodash/get';
import SavingsPotsEntity from '../entities/SavingsPotsEntity';
import SavingsPotDetailsEntity from '../entities/SavingsPotDetailsEntity';

export function parsePotListResponse(response) {
  const potDetails = new SavingsPotsEntity();
  const _potList = [];
  // the response object differs at times between object with a an array and a straight array
  const pots = get(response, 'pots.pots', get(response, 'pots', []));
  pots.map((potData) => {
    // creating object
    const pot = new SavingsPotDetailsEntity();
    pot.id = potData.id;
    pot.name = potData.name;
    pot.goalAmount = potData.goal.amount.value;
    pot.goalAmountCurrency = potData.goal.amount.currency;
    pot.goalWhen = potData.goal.when;
    pot.reference = potData.reference;
    pot.dayOfMonth = potData.schedule.recurrence.frequency.monthly.day_of_month;
    pot.monthlyContry = potData.schedule.recurrence.amount.value;
    pot.monthlyContryCurrency = potData.schedule.recurrence.amount.currency;
    pot.balance = potData.balance.value;
    _potList.push(pot);
    return true;
  });
  potDetails.pots = _potList;
  potDetails.unAllocatedData = get(response, 'unallocated_amount.value');
  return potDetails;
}

export function parseSinglePotResponse(response) {
  const pot = new SavingsPotDetailsEntity();
  pot.id = response.id;
  pot.name = response.name;
  pot.goalAmount = response.goal.amount.value;
  pot.goalAmountCurrency = response.goal.amount.currency;
  pot.goalWhen = response.goal.when;
  pot.reference = response.reference;
  pot.interval = response.schedule.recurrence.frequency.monthly.interval;
  pot.dayOfMonth = response.schedule.recurrence.frequency.monthly.day_of_month;
  pot.monthlyContry = response.schedule.recurrence.amount.value;
  pot.monthlyContryCurrency = response.schedule.recurrence.amount.currency;
  pot.balance = response.balance.value;
  return pot;
}

export function parsePaymentPotListResponse(response) {
  const potDetails = new SavingsPotsEntity();
  const _potList = [];
  const pots = get(response, 'pots.pots', get(response, 'pots', []));
  pots.map((potData) => {
    // creating object
    const pot = new SavingsPotDetailsEntity();
    pot.id = potData.id;
    pot.name = potData.name;
    pot.goalWhen = potData.goal.when;
    pot.reference = potData.reference;
    pot.balance = potData.balance.value;
    _potList.push(pot);
    return true;
  });
  potDetails.pots = _potList;
  potDetails.id = response.id;
  potDetails.unAllocatedData = get(response, 'pots.unallocated_amount.value');
  return potDetails;
}
